import {
  getJxicReportHtmlWrapper,
  getParagraphHtml,
  handleStyleConfig,
  sectionHtmlWrapper
} from '@/utils/generate-html/layout'
// import { jxicIcon } from '@/components/procurement-report/jxic-icon'
import { generateTableHtml } from '@/utils/generate-html'
// const jxicIcon = require('@/assets/images/query-stats/jxic-icon.png')

const getReportValue = (config, name) => {
  return config.find(item => item.name === name)?.value
}

/**
 * 报告封面
 * @returns {string}
 */
const getJxicPageCoverHtml = ({ reportVariables, jxicIcon }) => {
  const period = getReportValue(reportVariables, '报表周期')
  const generationDate = getReportValue(reportVariables, '生成日期')

  return `
  <div class="report-cover">
    <div class="jxic-logo" style="text-align: right; margin-bottom: 68px;">
      <img style="width: 200px;" src="${jxicIcon}" alt="" />
     </div>
    <div class="report-tip" style="font-size: 22px">
      <div>内部资料</div>
      <div>注意保存</div>
    </div>
    <div class="report-title-wrap" style="text-align: center">
      <div
        class="report-title"
        style="
          width: 400px;
          font-size: 48px;
          color: #c00000;
          text-align: center;
          margin: 0 auto;
          line-height: 1.6;
          font-weight: bold;
          font-family: FZXiaoBiaoSong-B05S;
        "
      >
        集团电子采购平台运行情况简报
      </div>
    </div>
    <div
      class="report-cycle"
      style="
        text-align: center;
        font-size: 24px;
        margin-top: 24px;
        margin-bottom: 24px;
      "
    >
      （${period}）
    </div>
    <div
      class="report-info"
      style="
        text-align: justify;
        font-size: 22px;
        border-bottom: 4px solid #c00000;
        padding: 16px 48px;
      "
    >
      <span>江投集团投资开发部</span>
      <span style="float: right">${generationDate}</span>
    </div>
  </div>
  `
}

const getJxicSectionHtml = ({ title = '', paragraphList = [] }) => {
  const paragraphHtmlList = paragraphList.map(item => {
    let paragraphHtml = item.content
    if (item.title) {
      paragraphHtml = `<strong>${item.title}</strong>${item.content}`
    }
    if (item.tableConfig) {
      const tableHtml = generateTableHtml({
        needHtmlWrapper: false,
        needPageWrapper: false,
        tableHead: { fixedPrev: item.tableConfig.head },
        tableData: item.tableConfig.body,
        tableConfig: {
          styleConfig: {
            tableStyle: { border: 'none', width: '100%', marginBottom: '10px' },
            tbodyStyle: { border: '1px solid black', fontSize: '24px' }
          }
        }
      })
      paragraphHtml += tableHtml
    }
    if (item.imageConfig) {
      const imageStyleStr = handleStyleConfig(item.imageConfig.style)
      const imageHtml = `
      <div style="text-align: center">
        <img src="${item.imageConfig.src}" style="${imageStyleStr}" />
      </div>
      `
      paragraphHtml += imageHtml
    }
    return getParagraphHtml(paragraphHtml, {
      fontSize: '24px',
      lineHeight: 1.5,
      textAlign: 'justify'
    })
  })

  return sectionHtmlWrapper({
    title,
    titleStyle: {
      fontSize: '22px',
      fontWeight: 'bold',
      textIndent: '2em',
      marginTop: '10px'
    },
    sectionStyle: {
      padding: '0 40px'
    },
    htmlString: paragraphHtmlList.join('')
  })
}

const getReportLeadHtml = ({ reportVariables }) => {
  const paragraphList = [
    {
      content: `集团电子采购平台自上线运行以来，总体运行情况较好，投资开发部定期对上线的采购项目进行分析，现将${getReportValue(
        reportVariables,
        '报表周期'
      )}运行情况报告如下。`
    }
  ]
  return getJxicSectionHtml({ paragraphList })
}

const getJxicPurchaserTableConfig = reportVariables => {
  const indexCol = { content: '序号', width: '60px', align: 'center' }
  const companyNameCol = { content: '公司名称', align: 'center' }
  const releaseOrderNum = { content: '发布项目量（项）', align: 'center' }
  const releaseOrderBudget = {
    content: '发布项目预算金额（万元）',
    align: 'center'
  }
  const tableHead = [
    indexCol,
    companyNameCol,
    releaseOrderNum,
    releaseOrderBudget
  ]
  const ordersBySubCompany =
    getReportValue(reportVariables, '按子公司统计项目') || []
  const orderList = ordersBySubCompany.map((item, index) => {
    return {
      rankNum: index + 1,
      companyName: getReportValue(item, '公司名称'),
      releaseOrderNum: getReportValue(item, '项目数量'),
      releaseOrderBudget: getReportValue(item, '预算金额')
    }
  })
  // 二级采购企业列表
  const tableData = orderList.map(item => {
    return tableHead
      .map(head => {
        if (head.content === indexCol.content) return item.rankNum
        if (head.content === companyNameCol.content) return item.companyName
        if (head.content === releaseOrderNum.content) {
          return item.releaseOrderNum || '0'
        }
        if (head.content === releaseOrderBudget.content) {
          return item.releaseOrderBudget || '0'
        }
      })
      .map(rowValue => {
        return {
          content: rowValue,
          align: 'center'
        }
      })
  })
  const orderCountSumBySubCompany = getReportValue(
    reportVariables,
    '按子公司统计项目数量汇总'
  )
  const budgetSumBySubCompany = getReportValue(
    reportVariables,
    '按子公司统计项目预算金额汇总'
  )

  // 在表格数据末尾添加合计
  tableData.push([
    { content: '合计', colspan: 2, align: 'center' },
    { content: orderCountSumBySubCompany, align: 'center' },
    { content: budgetSumBySubCompany, align: 'center' }
  ])
  return {
    head: tableHead,
    body: tableData
  }
}

const getJxicAgencyTableConfig = reportVariables => {
  const indexCol = { content: '序号', width: '60px', align: 'center' }
  const agencyNameCol = { content: '代理机构名称', align: 'center' }
  const releaseOrderNum = { content: '代理项目量（项）', align: 'center' }
  const releaseOrderBudget = {
    content: '委托项目预算金额（万元）',
    align: 'center'
  }
  const tableHead = [
    indexCol,
    agencyNameCol,
    releaseOrderNum,
    releaseOrderBudget
  ]
  const entrustCompanyDetails =
    getReportValue(reportVariables, '代理机构明细列表') || []
  const orderList = entrustCompanyDetails.map((item, index) => {
    return {
      rankNum: index + 1,
      companyName: getReportValue(item, '公司名称'),
      releaseOrderNum: getReportValue(item, '项目数量'),
      releaseOrderBudget: getReportValue(item, '预算金额')
    }
  })
  // 代理机构列表
  const tableData = orderList.map(item => {
    return tableHead
      .map(head => {
        if (head.content === indexCol.content) return item.rankNum
        if (head.content === agencyNameCol.content) return item.companyName
        if (head.content === releaseOrderNum.content) {
          return item.releaseOrderNum || '0'
        }
        if (head.content === releaseOrderBudget.content) {
          return item.releaseOrderBudget || '0'
        }
      })
      .map(rowValue => {
        return {
          content: rowValue,
          align: 'center'
        }
      })
  })

  const entrustCompanyDetailsOrderCountSum = getReportValue(
    reportVariables,
    '代理机构明细列表项目数量汇总'
  )
  const entrustCompanyDetailsOrderBudgetSum = getReportValue(
    reportVariables,
    '代理机构明细列表项目预算金额汇总'
  )

  // 在表格数据末尾添加合计
  tableData.push([
    { content: '合计', colspan: 2, align: 'center' },
    { content: entrustCompanyDetailsOrderCountSum, align: 'center' },
    { content: entrustCompanyDetailsOrderBudgetSum, align: 'center' }
  ])
  return {
    head: tableHead,
    body: tableData
  }
}

const getJxicSupplierTableConfig = reportVariables => {
  const indexCol = { content: '序号', width: '60px', align: 'center' }
  const supplierNameCol = { content: '供应商名称', align: 'center' }
  const tradeNumCol = { content: '参与次数（项）', align: 'center' }
  const winNumCol = { content: '成交次数（项）', align: 'center' }
  const winAmountCol = { content: '中标金额（万元）', align: 'center' }
  const tableHead = [
    indexCol,
    supplierNameCol,
    tradeNumCol,
    winNumCol,
    winAmountCol
  ]
  const winSuppliersByWinPrice =
    getReportValue(reportVariables, '按成交金额统计成功供应商列表') || []
  const orderList = winSuppliersByWinPrice.map((item, index) => {
    return {
      rankNum: index + 1,
      supplierName: getReportValue(item, '供应商名称'),
      tradeCount: getReportValue(item, '参与次数'),
      winCount: getReportValue(item, '成交次数'),
      winPrice: getReportValue(item, '成交金额')
    }
  })
  const tableData = orderList.map(item => {
    return tableHead
      .map(head => {
        if (head.content === indexCol.content) return item.rankNum
        if (head.content === supplierNameCol.content) return item.supplierName
        if (head.content === tradeNumCol.content) return item.tradeCount || '0'
        if (head.content === winNumCol.content) {
          return item.winCount || '0'
        }
        if (head.content === winAmountCol.content) {
          return item.winPrice || '0'
        }
      })
      .map(rowValue => {
        return {
          content: rowValue,
          align: 'center'
        }
      })
  })

  const winSupplierWinPriceSum = getReportValue(
    reportVariables,
    '按成交金额统计成功供应商列表成交金额汇总'
  )

  // 在表格数据末尾添加合计
  tableData.push([
    { content: '合计', colspan: 4, align: 'center' },
    { content: winSupplierWinPriceSum, align: 'center' }
  ])
  return {
    head: tableHead,
    body: tableData
  }
}

/**
 * 总体情况
 */
const getOverallHtml = ({ reportVariables, bidMethodSrc, projectTypeSrc }) => {
  const statisticEndDate = getReportValue(reportVariables, '统计截止日期')
  const subCompanyCount = getReportValue(reportVariables, '关联二级企业数量')
  const subCompanySubordinateCount = getReportValue(
    reportVariables,
    '二级企业下属单位数'
  )
  const currentYear = getReportValue(reportVariables, '当年年份')
  const currentYearOrderNum = getReportValue(
    reportVariables,
    '当年已发布成功项目数'
  )
  const currentYearFinishOrderNum = getReportValue(
    reportVariables,
    '当年已完结项目数'
  )
  const currentYearBudget = getReportValue(reportVariables, '当年成交预算金额')
  const currentYearWinPrice = getReportValue(reportVariables, '当年成交金额')
  const currentYearSavePrice = getReportValue(reportVariables, '当年节省资金')
  const currentYearSavePriceRatio = getReportValue(
    reportVariables,
    '当年节省资金占预算金额比例'
  )
  const period = getReportValue(reportVariables, '报表周期')
  const currentPeriodOrderNum = getReportValue(
    reportVariables,
    '当前周期已发布项目数'
  )
  const currentPeriodBudget = getReportValue(
    reportVariables,
    '当前周期预算金额'
  )
  const currentPeriodFinishOrderNum = getReportValue(
    reportVariables,
    '当前周期已完结项目数'
  )
  const currentPeriodWinBudget = getReportValue(
    reportVariables,
    '当前周期成交预算金额'
  )
  const currentPeriodWinPrice = getReportValue(
    reportVariables,
    '当前周期成交金额'
  )
  const currentPeriodSavePrice = getReportValue(
    reportVariables,
    '当前周期节约资金数'
  )
  const ordersByPurchaseType = getReportValue(
    reportVariables,
    '按采购类型统计项目列表'
  )
    .map(item => {
      let purchaseTypeName = getReportValue(item, '采购类型名称')
      if (purchaseTypeName === '谈判采购') {
        purchaseTypeName += '（包含竞争性磋商和竞争性谈判）'
      }
      return `${purchaseTypeName}类${getReportValue(
        item,
        '发布项目数'
      )}项，占比${getReportValue(item, '占比')}%`
    })
    .join('；')
  const ordersByProjectType = getReportValue(
    reportVariables,
    '按项目类型统计项目'
  )
    .map(item => {
      return `${getReportValue(item, '项目类型名称')}${getReportValue(
        item,
        '发布项目数'
      )}项，占比${getReportValue(item, '占比')}%`
    })
    .join('；')
  const ordersBySubCompanyTopFive = getReportValue(
    reportVariables,
    '按子公司统计项目'
  )
    .slice(0, 5)
    .map(item => {
      return `${getReportValue(item, '公司名称')}${getReportValue(
        item,
        '项目数量'
      )}项`
    })
    .join('，')
  const entrustCompanyCount = getReportValue(reportVariables, '代理机构数')
  const entrustOrderCount = getReportValue(reportVariables, '代理采购项目数')
  const entrustOrderRatio = getReportValue(reportVariables, '代理采购项目占比')
  const entrustOrderTotalBudget = getReportValue(
    reportVariables,
    '代理采购项目预算金额'
  )
  const entrustOrderTotalWinBudget = getReportValue(
    reportVariables,
    '代理采购项目成交预算金额'
  )
  const entrustOrderTotalWinPrice = getReportValue(
    reportVariables,
    '代理采购项目成交金额'
  )
  const entrustOrderTotalSavePrice = getReportValue(
    reportVariables,
    '代理机构节约资金'
  )
  const supplierCount = getReportValue(reportVariables, '投标供应商总数')
  const supplierTradeCount = getReportValue(
    reportVariables,
    '供应商累计参与次数'
  )
  const supplierWinCount = getReportValue(reportVariables, '成交供应商总数')
  const supplierWinProvinceCount = getReportValue(
    reportVariables,
    '成交供应商所在省份数'
  )
  const winSuppliersByProvince = getReportValue(
    reportVariables,
    '按省份统计成交供应商列表'
  )
    .map(item => {
      return `${getReportValue(item, '省份名称')}${getReportValue(
        item,
        '供应商数量'
      )}家，占比${getReportValue(item, '占比')}%`
    })
    .join('；')

  const paragraphList = [
    {
      content: `截至${statisticEndDate}，集团共有${subCompanyCount}家二级企业和${subCompanySubordinateCount}家所属企业在集团电子采购平台上线使用,${currentYear}年上线采购项目${currentYearOrderNum}个，完结项目${currentYearFinishOrderNum}项，完结项目预算金额${currentYearBudget}亿元，成交金额${currentYearWinPrice}亿元，节约资金${currentYearSavePrice}亿元，节约资金占预算金额的${currentYearSavePriceRatio}%。`
    },
    {
      content: `${period}，集团电子采购平台共发布采购项目${currentPeriodOrderNum}项，预算金额${currentPeriodBudget}亿元，完成采购项目${currentPeriodFinishOrderNum}项，预算金额${currentPeriodWinBudget}亿元，成交金额${currentPeriodWinPrice}亿元，节约资金${currentPeriodSavePrice}亿元。`
    },
    {
      title: '1.从采购方式来看。',
      content: `${ordersByPurchaseType}。`,
      imageConfig: { src: bidMethodSrc, style: { width: '500px' } }
    },
    {
      title: '2.从项目类型来看。',
      content: `${ordersByProjectType}。`,
      imageConfig: { src: projectTypeSrc, style: { width: '500px' } }
    },
    {
      title: '3.从采购企业来看。',
      content: `发布数量前五的二级企业分别是:${ordersBySubCompanyTopFive}。具体如下:`,
      tableConfig: getJxicPurchaserTableConfig(reportVariables)
    },
    {
      title: '4.从招标代理机构来看。',
      content: `${period}共委托招标代理机构${entrustCompanyCount}家，代理采购项目${entrustOrderCount}项，占比${entrustOrderRatio}%，委托项目预算金额${entrustOrderTotalBudget}亿元，其中成交项目预算金额${entrustOrderTotalWinBudget}亿元，成交金额${entrustOrderTotalWinPrice}亿元，节约资金${entrustOrderTotalSavePrice}亿元。具体如下：`,
      tableConfig: getJxicAgencyTableConfig(reportVariables)
    },
    {
      title: '5.从供应商来看。',
      content: `${period}参与项目的供应商共有${supplierCount}家，累计参与次数${supplierTradeCount}次，其中成交供应商${supplierWinCount}家。成交供应商分布全国${supplierWinProvinceCount}个省份，${winSuppliersByProvince}。成交金额排名前五的供应商情况如下：`,
      tableConfig: getJxicSupplierTableConfig(reportVariables)
    }
  ]

  return getJxicSectionHtml({ title: '一、总体情况', paragraphList })
}

const getJxicSaveMoneyTableConfig = reportVariables => {
  const indexCol = { content: '序号', width: '60px', align: 'center' }
  const orderNameCol = { content: '项目名称', align: 'center', width: '120px' }
  const budgetCol = { content: '预算金额（万元）', align: 'center' }
  const winnerAmountCol = { content: '成交价（万元）', align: 'center' }
  const saveAmountCol = { content: '节约资金（万元）', align: 'center' }
  const tableHead = [
    indexCol,
    orderNameCol,
    budgetCol,
    winnerAmountCol,
    saveAmountCol
  ]
  const savePriceOrders = getReportValue(
    reportVariables,
    '节约资金项目列表'
  ).map((item, index) => {
    return {
      rankNum: index + 1,
      orderName: getReportValue(item, '项目名称'),
      budget: getReportValue(item, '预算金额'),
      winnerAmount: getReportValue(item, '成交金额'),
      saveAmount: getReportValue(item, '节约资金')
    }
  })
  const tableData = savePriceOrders.map(item => {
    return tableHead
      .map(head => {
        if (head.content === indexCol.content) return item.rankNum
        if (head.content === orderNameCol.content) return item.orderName
        if (head.content === budgetCol.content) {
          return item.budget || '0'
        }
        if (head.content === winnerAmountCol.content) {
          return item.winnerAmount || '0'
        }
        if (head.content === saveAmountCol.content) {
          return item.saveAmount || '0'
        }
      })
      .map(rowValue => {
        return {
          content: rowValue,
          align: 'center'
        }
      })
  })
  return {
    head: tableHead,
    body: tableData
  }
}

const getDataAnalysisHtml = ({ reportVariables }) => {
  const lastPeriod = getReportValue(reportVariables, '上个报表周期')
  const periodCompare = getReportValue(reportVariables, '周期相比')
  const momOrderNumCompare = getReportValue(reportVariables, '环比发布数量相比')
  const momOrderNum = getReportValue(reportVariables, '环比发布数量')
  const momBudgetCompare = getReportValue(reportVariables, '环比预算金额对比')
  const momBudget = getReportValue(reportVariables, '环比预算金额')
  const momOrderNumDetails = getReportValue(
    reportVariables,
    '环比发布数量详情列表'
  )
    .map(item => {
      return `${getReportValue(item, '公司名称')}发布数量${getReportValue(
        item,
        '环比发布数量对比'
      )}${getReportValue(item, '环比发布数量')}项`
    })
    .join('，')
  const period = getReportValue(reportVariables, '报表周期')
  const currentPeriodSavePrice = getReportValue(
    reportVariables,
    '当前周期节约资金数'
  )
  const currentPeriodWinBudget = getReportValue(
    reportVariables,
    '当前周期成交预算金额'
  )
  const currentPeriodSavePriceRatio = getReportValue(
    reportVariables,
    '当前周期节约资金占比'
  )
  const employeeCount = getReportValue(reportVariables, '员工数量')

  const paragraphList = [
    {
      title: '1.从发布数量和预算金额来看。',
      content: `所属企业上线集团电子采购平台的采购项目数量与${lastPeriod}相比为${periodCompare}，发布数量${momOrderNumCompare}${momOrderNum}项，预算金额${momBudgetCompare}${momBudget}亿元。其中${momOrderNumDetails}。`
    },
    {
      title: '2.从节约资金和增加收益来看。',
      content: `${period}成交项目共节约资金${currentPeriodSavePrice}亿元，占成交项目预算金额${currentPeriodWinBudget}亿元的${currentPeriodSavePriceRatio}%，节约资金量前5分别为：`,
      tableConfig: getJxicSaveMoneyTableConfig(reportVariables)
    },
    {
      title: '3.从企业人员注册来看。',
      content: `${period}注册人员数为${employeeCount}。`
    }
  ]
  return getJxicSectionHtml({ title: '二、数据分析', paragraphList })
}

const getOtherOrderTableConfig = reportVariables => {
  const indexCol = { content: '序号', width: '60px', align: 'center' }
  const companyNameCol = { content: '公司名称', align: 'center' }
  const orderNameCol = { content: '项目名称', align: 'center', width: '120px' }
  const budgetCol = { content: '预算金额（万元）', align: 'center' }
  const releaseTimeCol = { content: '发布时间', align: 'center' }
  const openTimeCol = { content: '开标时间', align: 'center' }
  const tableHead = [
    indexCol,
    companyNameCol,
    orderNameCol,
    budgetCol,
    releaseTimeCol,
    openTimeCol
  ]
  const ongoingOrders = getReportValue(
    reportVariables,
    '正在进行中项目列表'
  ).map((item, index) => {
    return {
      rankNum: index + 1,
      companyName: getReportValue(item, '公司名称'),
      orderName: getReportValue(item, '项目名称'),
      budget: getReportValue(item, '预算金额'),
      releaseTime: getReportValue(item, '发布时间'),
      openTime: getReportValue(item, '开标时间')
    }
  })
  const tableData = ongoingOrders.map(item => {
    return tableHead
      .map(head => {
        if (head.content === indexCol.content) return item.rankNum
        if (head.content === companyNameCol.content) return item.companyName
        if (head.content === orderNameCol.content) return item.orderName
        if (head.content === budgetCol.content) {
          return item.budget || '0'
        }
        if (head.content === releaseTimeCol.content) {
          return item.releaseTime
        }
        if (head.content === openTimeCol.content) {
          return item.openTime
        }
      })
      .map(rowValue => {
        return {
          content: rowValue,
          align: 'center'
        }
      })
  })
  return {
    head: tableHead,
    body: tableData
  }
}

const getOtherHtml = ({ reportVariables }) => {
  const currentPeriodOngoingOrderNum = getReportValue(
    reportVariables,
    '当前周期正在进行中项目数'
  )

  const paragraphList = [
    {
      title: '1.正在采购的主要项目。',
      content: `正在进行的采购项目共有${currentPeriodOngoingOrderNum}项，按项目预算排名，前10的采购项目为：`,
      tableConfig: getOtherOrderTableConfig(reportVariables)
    }
  ]
  return getJxicSectionHtml({ title: '三、其他事项', paragraphList })
}

/**
 * 获取报告主体模板
 * @param {JxicWordBodyConfig} bodyConfig
 * @returns {string}
 */
export const getJxicBodyHtml = bodyConfig => {
  const coverHtml = getJxicPageCoverHtml(bodyConfig)
  const leadHtml = getReportLeadHtml(bodyConfig)
  const overallHtml = getOverallHtml(bodyConfig)
  const dataAnalysisHtml = getDataAnalysisHtml(bodyConfig)
  const otherHtml = getOtherHtml(bodyConfig)
  return coverHtml + leadHtml + overallHtml + dataAnalysisHtml + otherHtml
}

/**
 * 省投报告主体内容配置
 * @typedef JxicWordBodyConfig
 * @property {string} bidMethodSrc 招标方式饼图
 * @property {string} projectTypeSrc 项目类型饼图
 * @property {Array} reportVariables 报告数据列表
 */

/**
 * 获取省投自动化文档模板
 * @param {JxicWordBodyConfig} bodyConfig 主体内容配置
 * @returns {string}
 */
export const getJxicWordHtmlByConfig = bodyConfig => {
  const bodyHtml = getJxicBodyHtml(bodyConfig)

  return getJxicWordHtml(bodyHtml)
}

export const getJxicWordHtml = bodyHtml => {
  return getJxicReportHtmlWrapper({
    htmlString: bodyHtml
  })
}
